<template>
  <div>
    <div v-for="(stud_data, ind) in icard_data" :key="ind">
      <div class="cardbody" style="font-weight: 1000;">
        <div v-if="icard_data != ''" style="width: 18.3rem">
          <div>
            <div class="row">
              <img :src="stud_data.logo" height="70" width="80" alt="logo" />

              <span class="bold-print" v-html="stud_data.heading">
                <b>{{ stud_data.heading }}</b></span
              >
            </div>
            <center>
              <h3 class="bold-print pt-8">{{ stud_data.emp_code }}</h3>
            </center>
            <div class="empimg" style="margin-top: -3px !important">
              <center>
                <img
                  :src="stud_data.profile_photo_path"
                  class="box1"
                  style="width: 56%; height: 180px; border: black solid 2px"
                />
              </center>
            </div>
            <v-img
              style="height: 167px; margin-top: -26px;width:320px;"
              :src="stud_data.watermark"
            >
              <center>
                <div
                  class="text-center white--text pt-5 mt-10"
                  style="font-size: x-large; font-weight: bold"
                >
                  {{ stud_data.first_name }} &nbsp;&nbsp; {{stud_data.last_name}}
                </div>
                <div
                  class="text-center white--text"
                  style="font-size: large; font-weight: bold"
                >
                  {{ stud_data.designation }}
                </div>
                <div
                  style="
                    position: absolute;
                    bottom: 10px;
                    margin-right: 40%;
                    margin-left: -17px;
                  "
                  class="white--text mb-1"
                >
                  <img
                    :src="stud_data.sign"
                    style="width: 120px; height: 30px; padding-left: 25px"
                    alt="logo"
                  />
                </div>
                <div
                  style="position: absolute; bottom: 0px"
                  class="white--text ml-1"
                >
                  <strong> Authorised Signatory</strong>
                </div>
                <div
                    style="
                      position: absolute;
                      right: -3px;
                      bottom: -12px;
                      width: 65px;
                      height: 65px;
                    "
                  >
                    <img
                      src="https://vgespl-sbpps.s3.ap-south-1.amazonaws.com/Role_link_icons/sbpps/1/rids_year_cmyk(14-08-2025)-np-02(1)(1)99rpcrtq8n.png"
                      style="
                        width: 45px;
                        height: 45px;
                        object-fit: contain;
                      "
                    />
                  </div>
              </center>
            </v-img>
          </div>
        </div>
      </div>
      <br />
      <div
        style=" font-weight: 1000;"
        class="cardbody1 pagebreak"
        :class="{ 'bottom': isEnabledSpecific }"
      >
        <div v-if="icard_data != ''" style="width: 18.3rem">
          <div :class="{ 'mrgn': isEnabledSpecific }" style="margin-top: -2px;">
            <v-img :src="stud_data.watermark_back"></v-img>
          </div>
          <div class="ml-2 bold-print" style="font-size: small">
            <strong>Date of Birth :- </strong> {{ stud_data.emp_dob }}<br />
            <strong>Blood Group :- </strong>{{ stud_data.emp_blood_group
            }}<br />
            <strong>Contact No. :- </strong> {{ stud_data.emp_contact }}<br />
            <strong>Email :- </strong>{{ stud_data.emp_email_official }}<br />
          </div>
          <div class="ml-2 bold-print" style="font-size: small; height: 55px">
            <strong>Address :- </strong>{{ stud_data.emp_address }}<br />
          </div>
          <span class="ml-3"><strong>Instruction</strong></span>
          <hr />
          <v-row
            style="font-size: xx-small; font-weight: bold; text-indent: -1.5em; padding-left: 1.5em;"
            dense
            class="ml-3"
            v-for="(i, index) in stud_data.instruction"
            :key="index"
          >
            <b>{{ index + 1 }} . {{ i.topic }}</b>
          </v-row>
          <center>
            <barcode
              height="20"
              width="1"
              v-model="stud_data.emp_code"
              v-bind:value="stud_data.emp_code"
            >
            </barcode>
          </center>
          <div :class="{ 'mrgn': isEnabledSpecific }" style="background: #0095cb;" class="mt-1 bold-print">
            <v-row class="ml-2" dense style="font-size: x-small">{{
              stud_data.school_name
            }}</v-row>
            <hr />
            <v-row dense class="ml-2" style="font-size: x-small"
              >{{ stud_data.school_address }}
            </v-row>
            <v-row dense class="ml-2" style="font-size: x-small"
              >Contact No. :- {{ stud_data.school_contact }}</v-row
            >
            <v-row dense class="ml-2" style="font-size: x-small"
              >Email :- {{ stud_data.email }} <v-spacer></v-spacer> Website :-
              {{ stud_data.website }}
            </v-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
  components: {
    barcode: VueBarcode,
  },
  data: () => ({
    stud_data: null,
    comp_load: false,
    icard_data: [],
  }),
  mounted() {
    this.inst_data = JSON.parse(localStorage.getItem("inst_data"));
    this.icard_data = JSON.parse(localStorage.getItem("icard_data"));
    this.isEnabledSpecific = localStorage.getItem("isEnabledSpecific")==="true";
  },
  methods: {
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>
<style scoped>
.bottom {
  -ms-transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  transform: rotate(180deg);
}
.mrgn {
  /* margin-top: -2px; */
  margin-right: 3px;
  margin-left: -2px;
  margin-bottom: 3px;
}
.box1 {
}
.boxnew {
  background-color: white;
  width: 300.52755905896px;
  height: 204.01889764021797px;
  padding-left: 3px !important;
  padding-right: 2px !important;
  background-repeat: no-repeat !important;
}
.cardbody {
  width: 300px;
  display: inline-block;
  border-radius: 5px;
  padding: 5px;
  height: 485px;
  padding-top: 15px;
}
.cardbody1 {
  width: 300px;
  display: inline-block;
  border-radius: 5px;
  padding: 5px;
  height: 490px;
  /* padding-top: 15px; */
}
.schlname {
  color: #023a9c;
  font-size: large;
  font-weight: bold;
}

.schladdr {
  font-weight: bold;
}

.schlphone {
  font-weight: bold;
}

.signature {
  width: 38%;
  height: 60px;
  margin-bottom: 13px;
  margin-right: -70px;
}
* {
  -webkit-print-color-adjust: exact;
  print-color-adjust: exact;
}

#barcode2 {
  /* height: 188px; */
  margin-top: 5px;
  height: 60px;

  /* width: 100%; */
  width: 50%;
}
/* .rids-text {
  color: #ff0000 !important;
  font-size: 10px;
  line-height: 1.1;
  margin: 0;
  white-space: normal;
  word-break: break-word;
} */
@media print {
  .bold-print{
    font-weight: 800 !important;
  }
  .pagebreak {
    page-break-before: always !important;
  }

  #noprint {
    display: none !important;
  }
  @page {
    margin: -0.2645833mm;
    /* size: 54.102mm 86.614mm; */
    size: 53mm 86.614mm;
  }
  .logo {
    /* width: 80%; */
    height: 85%;
  }
}
ul.inst {
  list-style-type: "*";
  font-weight: 500;
  font-size: 14px;
  text-align: left;
}
.empimg {
  margin-bottom: 20px;
  margin-top: 8px;
}
</style>

